import React from "react"
import type { IDashboardContextValue } from "connected-components/dashboard/context/types"
import type { InstrumentWithMetadata } from "helpers/types/instruments/metadata"
import type { TabIconComponent } from "connected-components/op-layout-engine/types"
import type { ArtifactKind } from "./ai-artifact/types"

/**
 * Module type constants
 */
export const MODULE_TYPES = {
  ASSET_VIEW: "asset-view",
  KPI: "kpi",
  GRAPH: "graph",
  FACTORS: "factors",
  AI_ARTIFACT: "ai-artifact",
} as const

export type ModuleType = typeof MODULE_TYPES[keyof typeof MODULE_TYPES]

export interface ModuleDefinition {
  type: ModuleType
  title: string
  icon?: TabIconComponent
  removable: boolean
  editable: boolean
  description: string
}

/**
 * Dependencies required for rendering a module
 * TODO[APP-2461]: Improve module renderer dependencies architecture
 */
export interface ModuleRenderDependencies {
  TradeContext: React.Context<IDashboardContextValue>
  instrumentsWithMetadata: Record<string, InstrumentWithMetadata>
  hasMultipleInstruments?: boolean
  contentSets?: unknown[]
  modelMetadata?: unknown
  config?: ModuleConfig
}

export interface ModuleConfig {
  artifactId?: string
  pinnedId?: string
  kind?: ArtifactKind
  title?: string
  isPinning?: boolean
  hasError?: boolean
  [key: string]: unknown
}

export interface DashboardModule {
  id: string
  type: ModuleType
  config: ModuleConfig
}

export interface ModulesState {
  modules: DashboardModule[]
}

export interface ModulesContextValue extends ModulesState {
  isPreferencesLoaded: boolean
  addModule: (module: { type: ModuleType, config?: ModuleConfig }) => string
  removeModule: (moduleId: string) => void
  updateModule: (moduleId: string, updates: Partial<DashboardModule>) => void
}
